import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import "@/i18n";
import "@/App.css";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

const SUPPORTED = ["ar", "en"];

function LangLayout({ children }) {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  useEffect(() => {
    if (lang && SUPPORTED.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  if (!SUPPORTED.includes(lang)) {
    return <Navigate to="/ar" replace />;
  }
  return (
    <>
      <Header />
      {children}
      <Footer />
      <CookieBanner />
    </>
  );
}

function LangRouter() {
  return (
    <LangLayout>
      <Routes>
        <Route index element={<Home />} />
        <Route path="privacy" element={<LegalPage ns="privacy" />} />
        <Route path="cookies" element={<LegalPage ns="cookies" />} />
        <Route path="terms" element={<LegalPage ns="terms" />} />
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </LangLayout>
  );
}

function NotFoundRedirect() {
  const location = useLocation();
  const first = location.pathname.split("/").filter(Boolean)[0];
  if (first && SUPPORTED.includes(first)) return null;
  return <Navigate to="/ar" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ar" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang/*" element={<LangRouter />} />
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}
